import type { Provider, Type } from '@angular/core';
import type { AlainAuthConfig } from '@delon/util/config';
import type { MicroNgConfig } from '@eliboo/micro-ng/core';
import type { MicroRouterService } from '@eliboo/micro-ng/router';

import { DELON_AUTH_CONFIG, DelonTokenService } from '@eliboo/micro-ng/auth-delon';
import { MICRO_NG_CONFIG } from '@eliboo/micro-ng/core';
import { MICRO_ROUTE_HOST } from '@eliboo/micro-ng/router';

export type InitMicroNgOptions = {
  alainAuthConfig: AlainAuthConfig;
  microNgConfig: MicroNgConfig;
  MicroRouterServiceClass: Type<MicroRouterService<string>>;
  routeHost: string;
};

export function provideMicroNg(options: InitMicroNgOptions) {
  const { routeHost, alainAuthConfig, microNgConfig, MicroRouterServiceClass } = options;
  const microNgProvides: Provider[] = [
    MicroRouterServiceClass,
    DelonTokenService,
    { provide: MICRO_ROUTE_HOST, useValue: routeHost },
    { provide: MICRO_NG_CONFIG, useValue: microNgConfig },
    { provide: DELON_AUTH_CONFIG, useValue: alainAuthConfig },
  ];
  return microNgProvides;
}
